"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var lodash_1 = __importDefault(require("lodash"));
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var routes_1 = require("@/routes");
var PaymentFormItemsTable = /** @class */ (function (_super) {
    __extends(PaymentFormItemsTable, _super);
    function PaymentFormItemsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showSelect = false;
        return _this;
    }
    Object.defineProperty(PaymentFormItemsTable.prototype, "totalCost", {
        get: function () {
            var bids = this.value.map(function (x) { return x.highest_bid_amount; });
            return lodash_1.default.sum(bids);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormItemsTable.prototype, "headers", {
        get: function () {
            return [
                {
                    text: "Name",
                    value: "truncated_name",
                    align: "start",
                },
                {
                    text: "",
                    value: "highest_bid_amount",
                    align: "end"
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormItemsTable.prototype, "chargeHeaders", {
        get: function () {
            return [
                {
                    text: "Name",
                    value: "name",
                },
                {
                    text: "Amount",
                    value: "currency_amount",
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    PaymentFormItemsTable.prototype.formatCurrency = function (number) {
        var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });
        return formatter.format(number);
    };
    PaymentFormItemsTable.prototype.itemShowLink = function (item) {
        return (0, route_1.default)(routes_1.BOARD_SPECIFIED_ITEM_SHOW_PAGE, {
            item: item.hash_id,
            board: item.board.abbr
        });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Array })
    ], PaymentFormItemsTable.prototype, "value", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Array })
    ], PaymentFormItemsTable.prototype, "items", void 0);
    PaymentFormItemsTable = __decorate([
        vue_property_decorator_1.Component
    ], PaymentFormItemsTable);
    return PaymentFormItemsTable;
}(vue_property_decorator_1.Vue));
exports.default = PaymentFormItemsTable;
